import { WarpWeftPlan } from './warp-weft-plan';
import { WarpWeftPlanRepeat } from './warp-weft-plan-repeat';

export interface WarpSpec {
  id: string;
  designId: string;
  code: string;
  shadesPerWarp: number;
  startAtEnd: number;
  endsPerRepeat: number;
  extrasPerRepeat: number;
  groundEnds: number;
  warpPlan: WarpWeftPlan[];
  warpPlanRepeats: WarpWeftPlanRepeat[];
}
